export default __webpack_public_path__ + "static/media/apple.0a5d8802.svg";